import MESSAGES from 'constants/messages';
import {
  stringIsInvalid,
  stringMaxLengthIsInvalid,
} from 'store/utils/validators';

export default (ruleName?: string) => {
  if (!ruleName || stringIsInvalid(ruleName)) {
    return MESSAGES.RULES.NAME.REGEX.CREATE;
  }

  if (stringMaxLengthIsInvalid(ruleName)) {
    return MESSAGES.RULES.NAME.MAX_LENGTH;
  }

  return undefined;
};
